import request from '@/utils/request';
import { type R, type RL, type RP, type ApiResult, RParam } from '@/api';
import type { Dictionary, DictCopy } from './model';
import LzdAjax from '@/utils/lzd-ajax';

const BASE_URL = '/bsl/tenant/dict';

/**
 * 分页查询字典列表
 */
export async function pageDictionaries(params: RP) {
  const res = await request.post<R<RL<Dictionary>>>(
    `${BASE_URL}/query/page`,
    params
  );
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 查询字典列表
 */
export async function listDictionaries(params: RP) {
  const res = await request.post<ApiResult<Dictionary[]>>(
    `${BASE_URL}/query/list`,
    params
  );
  return res.data.code === 0 ? res.data.data : Promise.reject(res.data);
}

/**
 * 查询单个字典列表
 */
export async function querysingleDictionary(params: RP) {
  const res = await request.post<ApiResult<Dictionary>>(
    `${BASE_URL}/query/single`,
    params
  );
  return res.data.code === 0 ? res.data.data : Promise.reject(res.data);
}
/**
 * 添加字典
 */
export async function addDictionary(data: Dictionary) {
  const res = await request.post<ApiResult<unknown>>(
    `${BASE_URL}/insert`,
    data
  );
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 修改字典
 */
export async function updateDictionary(data: Dictionary) {
  const res = await request.post<ApiResult<unknown>>(`${BASE_URL}/update`, {
    where: RParam.buildWhere({ seq: data.seq }),
    update: RParam.buildWhere(data)
  });
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 删除字典
 */
export async function removeDictionary(params: RP) {
  const res = await request.post<ApiResult<unknown>>(
    `${BASE_URL}/delete`,
    params
  );
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

/**
 * 复制字典数据
 */
export async function copyDictionaryData(data: DictCopy) {
  const res = await request.post<ApiResult<unknown>>(`${BASE_URL}/copy`, data);
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
}

async function queryDictDatas(dictCode: string) {
  const res = await request.post<ApiResult<unknown>>(`${BASE_URL}/copy`, data);
  return res.data.code === 0 ? res.data : Promise.reject(res.data);
  LzdAjax.post(BASE_URL + '/datas');
}

class dictionaryApi {
  static queryDictDatas = queryDictDatas;
  static querysingleDictionary = querysingleDictionary;
}
export default dictionaryApi;
